import CarrierBaseController from '../common/carrier.base.controller'

class CarrierEditController extends CarrierBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, CarrierService, Modal, $translate, $stateParams, CarrierBranchService, $q, UserBranchService) {

		super(Auth, $state, User, CarrierService, Modal, $translate, $stateParams, CarrierBranchService, $q, UserBranchService)

		this.$q = $q;
		this.CarrierBranchService = CarrierBranchService;
		this.UserBranchService = UserBranchService;

		this.defaultModel = {
			id: '',
			name: '',
			description: '',
			POCName: '',
			POCEmail: '',
			POCPhone: '',
			allBranch: [],
			defaultBranch: '',
			loggedInUser: User.getUser().id
		}
		this.model = angular.copy(this.defaultModel);
		this.branchData = [];
		this.branches = [];
	}

	$onInit() {
		this.loading = true;

		this.$q.all([
			this.Service.get(this.$stateParams.id),
			this.UserBranchService.getUserBranches(this.model.loggedInUser)
		])
			.then((data) => {
				this.defaultModel = data[0];
				this.rawId = data[0].id
				this.model.id = data[0].id
				this.model.name = data[0].name
				this.model.description = data[0].description
				this.model.POCEmail = data[0].POCEmail
				this.model.POCName = data[0].POCName
				this.model.POCPhone = data[0].POCPhone
				this.model.defaultBranch = data[0].branchId
				this.branchData = data[1].results;
			})
			.then(() => {
				this.loadBranch();
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.loading = false;
			})
	}

	reset() {
		this.resetMultiBranchSelection();
		this.model = angular.copy(this.defaultModel);
	}

	submit(evt) {
		// if (!this.validate()) {
		// 	return
		// }

		this.loading = true
		this.Service.update(this.rawId, {
			name: this.model.name,
			description: this.model.description,
			POCPhone: this.model.POCPhone,
			POCEmail: this.model.POCEmail,
			POCName: this.model.POCName,
			branchId: this.model.defaultBranch
		})
			.then((data) => {
				this.updateBranchGroup();
			})
			.then(() => {
				this.loading = false;
				window.history.go(-1)
			})
			.catch((err) => {
				this.loading = false
				err.data.errors.map((e) => {
					this.errorMessage += e.message + '<br/>'
				})
			})
	}

	// Reset Multi-Branch selection
	resetMultiBranchSelection() {
		let usersBranches = this.model.allBranch.map((data) => data.branchId)
		if (this.model.branch && this.model.branch.length && usersBranches) {
			this.model.allBranch.forEach((selectedBranch) => {
				this.branchData.filter((branch) => {
					let isIncludes = usersBranches.includes(branch.branchId)
					if (branch.branchId == selectedBranch.branchId) {
						branch.ticked = true;
					}
					if (!isIncludes) {
						branch.ticked = false;
					}
				})
			});
		}
		this.loadBranch();
	}

	loadBranch() {
		const searchObj = {
			queryJSON: {
				rules: [
					{
						field: 'carrierId',
						condition: '=',
						data: this.$stateParams.id
					}
				],
				operator: 'AND'
			}
		}

		this.CarrierBranchService.all(searchObj, 0, 100)
			.then((data) => {
				this.model.allBranch = data.results;
				this.model.allBranch.forEach((selectedBranch) => {
					this.branchData.filter((branch) => {
						if (branch.branchId == selectedBranch.branchId) {
							branch.ticked = true;
						}
					})
				});
			})
			.catch((err) => {
				console.log(err);
			});
	}

	updateBranchGroup() {
		this.branches = this.model.branch.map((b) => b.branchId)
		this.CarrierBranchService.updateBranchGroup(this.rawId, this.branches)
			.then((res) => {
				// console.log(res);
			})
			.catch((err) => {
				console.log(err);
			})
	}
}

export default CarrierEditController;


// WEBPACK FOOTER //
// ./client/app/components/carrier/edit/carrier.edit.controller.js